import { Alert } from 'antd';
import { memo } from 'react';

const AlertMessage = ({ info }) => {
  return info === null ? null : (
    <Alert message={info?.message} type={info?.type} />
  );
};

export default memo(AlertMessage);
